import { DeliveryStop, STOP_ACTION, STOP_STATUS } from "../domain/delivery-stop.types"

/** La ventana de entrega la carga cada centro médico en Odoo; no es obligatoria (Perú y Ecuador). */
export const AVISO_SIN_VENTANA_ENTREGA =
  "Este punto no tiene ventana de entrega (hora límite de recepción del centro médico): la fecha y hora programada se calculó solo con la hora de la cirugía y puede verse afectada. Agrega la ventana en el centro médico de Odoo."

const esHora = (valor?: string): boolean => !!valor && /^\d{1,2}:\d{2}$/.test(valor.trim())

/**
 * Una entrega de Odoo, todavía por salir, sin hora límite de recepción. Los que ya salieron o terminaron no se pueden reprogramar, así que no avisan.
 */
export const sinVentanaEntrega = (stop: Pick<DeliveryStop, "action" | "status" | "ventanaEntrega">): boolean =>
  stop.action === STOP_ACTION.DELIVERY &&
  (stop.status === STOP_STATUS.PENDING || stop.status === STOP_STATUS.CONFIRMED) &&
  !esHora(stop.ventanaEntrega?.horaLimiteRecepcionImplante)
